import { isEmpty } from "lodash"

import type { Visualization } from "@encoway/visual-editor"
import { Constants } from "@encoway/visual-editor"

export const buildStructuredBom = async (visualization: Visualization) => {
    const result = await visualization.result(Constants.BOM.Tree)
    // @ts-ignore
    const nodes: object[] | undefined = result.state.nodes

    if (nodes && !isEmpty(nodes)) {
        return nodes.reduce((structure: object[], node: any) => {
            const visuNode = visualization.cloud.find(node.id)

            // @ts-ignore
            const nodeItem = visuNode?._props?.product?.product
            if (node.state.excludeFromBOM === 1 || !nodeItem) {
                return [...structure]
            }

            return [
                ...structure,
                {
                    ...node,
                    nodeProperties: nodeItem,
                    quantity: 1
                }
            ]
        }, [])
    }
    return []
}
